import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { DashboardSeries } from '@core/models/dashboard/dashboard-series.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardSeriesAttendanceAdapter implements Adapter<DashboardSeries> {

  adapt(x: any): DashboardSeries {
    const organisationLogo = x.member.trainingPlanCourse.organisationProfile?.logo ?? '';
    const logoUrl = organisationLogo ? (organisationLogo.fileUrl ? (organisationLogo.fileUrl + '?filter=thumb&width=200&height=200&mode=outbound') : '') : '';
    return {
      courseId: x.member.trainingPlanCourse.id,
      courseName: x.member.trainingPlanCourse.name,
      cover: '',
      sessionId: '',
      seriesName: '',
      sessionTotal: 0,
      sessionName: '',
      sessionDate: new Date(x.year, (x.month ?? 1) - 1, x.day ?? 1),
      sessionEndDate: null,
      sessionStartTime: x.startTime ?? '',
      sessionEndTime: x.endTime ?? '',
      sessionLocation: (x.location || x.member.trainingPlanCourse.locationField)
        ? { id: '', name: x.location || x.member.trainingPlanCourse.locationField, description: '', address: { address: '', postcode: '', city: '', country: '' } }
        : null!,
      branchName: x.member.trainingPlanCourse.organisationProfile?.name ?? '',
      branchLogo: logoUrl,
      branchColor: '#0b145a',
      branchUrl: '',
      organisationId: x.member.trainingPlanCourse.organisationProfile?.id ?? '',
      organisationName: x.member.trainingPlanCourse.organisationProfile?.name ?? '',
      organisationLogo: logoUrl,
      isTrainingPlan: true,
      courseLocation: x.member.trainingPlanCourse.location ?? '',
      courseLocationName: x.member.trainingPlanCourse.locationField ?? '',
      courseDateType: x.member.trainingPlanCourse.dateType ?? ''
    } as DashboardSeries;
  }
}
